// @flow
import { router } from './router';

// What an account without an active subscription (`advancedData.blocked`: expired, canceled, banned, or
// its trial ended) can still open: its plan and the way to pay, its profile and password, the support,
// and Ajustes, where "Sair" is. Nothing with patient or clinic data: the rest of Ajustes stays greyed out
// there (SettingsMenu) and closed here.
const BLOCKED_ALLOWED_ROUTES = [
  'settingsList',
  'userConfig',
  'changePassword',
  'deleteMyAccount',
  'support',
  'backupRequest',
  'pricing',
  'subscriptionInfo',
  'subscriptionComplete',
  'notFound',
];

const routes = router.getNamedRoutes();
const OPEN_PATHS = new Set(BLOCKED_ALLOWED_ROUTES.map(name => routes[name]));

export const isOpenWhenBlocked = (path: string): boolean => OPEN_PATHS.has(path);

type Account = { blocked: boolean, subscriptionStatus: ?string };

// Where the gate (AuthenticatedRoute) sends a blocked account away from `path`, or null when it may stay:
// the plans when the trial ended (it never subscribed), its plan otherwise.
export const blockedRedirect = ({ blocked, subscriptionStatus, path }: Account & { path: string }): ?string => {
  if (!blocked || isOpenWhenBlocked(path)) return null;
  return subscriptionStatus === 'end_of_trial' ? 'pricing' : 'subscriptionInfo';
};

// A navigation link for `path` (the tab bar, the computer's header): a page the account can't open links
// straight to where the gate would send it. Through the closed page, every tap left one more Meu plano in
// the history, and "back" stayed on it.
export const blockedLinkTo = (path: string, account: Account): { to: string, closed: boolean } => {
  const redirect = blockedRedirect({ ...account, path });
  return redirect ? { to: routes[redirect], closed: true } : { to: path, closed: false };
};
